import React from 'react';
import { DigitalIDModal } from 'components';

export default function DigitalIDContainer() {
  return <DigitalIDModal />;
}
